import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as CashPrice from "../../price/styles/CashPrice";
import * as MonthlyPrice from "../../price/styles/MonthlyPrice";
import * as Text from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import {
    lineClampStyle,
    type LineClampStyleType,
} from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Lineclamp";

export const Header = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    min-height: 90px;
    padding: ${theme.space[2]}px;
    word-break: break-word;
    border-top: 1px solid ${theme.colors.silver};
    cursor: pointer;

    ${CashPrice.Text}, ${MonthlyPrice.Text} {
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        color: ${theme.colors.platinumDark};
    }
`;

export const Wrapper = styled.div<{ background?: boolean; selected?: boolean; included?: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-around;

    ${({ background, selected, included }) =>
        background &&
        css`
            background-color: ${theme.colors.white};
            box-shadow: ${selected || included ? "none" : "0 0 8px rgba(0, 0, 0, 0.25)"};

            ${selected &&
            css`
                box-shadow: 0 0 0 2px ${theme.colors.azure};
            `};

            ${included &&
            css`
                box-shadow: 0 0 0 2px ${theme.colors.platinumMedium};
            `};

            ${ImageWrapper} {
                overflow: hidden;
            }
        `}

    ${({ background }) =>
        !background &&
        css`
            ${Header} {
                padding-left: 0;
                padding-right: 0;
            }
        `};
`;

export const ImageWrapper = styled.div`
    position: relative;
    flex-shrink: 0;
    min-width: 100%;
    cursor: pointer;
    img {
        width: 100%;
        height: auto;
    }
`;

export const CheckboxWrapper = styled.div<{ noBackground?: boolean }>`
    align-self: flex-end;
    line-height: 1;
`;

export const HeaderTop = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
`;

export const Bottom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    /* Override default styling of the button text because else it will break the layout */
    ${Text.IconButton} {
        text-align: start;
        white-space: normal;
        @media ${getBreakpoint("only", "md")} {
            display: none;
        }
    }
`;

export const Footer = styled.div<{ darkVariant?: boolean }>`
    display: flex;
    align-items: center;
    column-gap: ${theme.space[2]}px;
    min-width: 100%;
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 3rem;
    background-color: ${({ darkVariant }) => (darkVariant ? theme.colors.mist : theme.colors.white)};
    cursor: pointer;

    &:not(:empty) {
        padding: ${theme.space[2]}px;
    }

    ${Button.Checkbox} {
        margin-left: auto;
        ${IconWrapper} {
            margin-left: 0;
        }
    }

    @supports not (column-gap: 0) {
        ${IconWrapper},
        ${Button.Checkbox} {
            margin-left: ${theme.space[2]}px;
        }
    }

    html[dir="rtl"] & {
        ${Button.Checkbox} {
            margin-left: 0;
            margin-right: auto;
            ${IconWrapper} {
                margin-right: 0;
            }
        }

        @supports not (column-gap: 0) {
            ${IconWrapper},
            ${Button.Checkbox} {
                margin-left: 0;
                margin-right: ${theme.space[2]}px;
            }
        }
    }
`;

export const Name = styled.div<LineClampStyleType>`
    display: inline-block;
    text-align: start;
    ${lineClampStyle};
    /* Override default lineclamp lines to 5 */
    -webkit-line-clamp: 5;
    line-clamp: 5;
`;

export const Description = styled.div`
    display: inline-block;
    max-width: 30px;
    span::before {
        font-size: 1.6rem;
    }
`;
